module.exports = __webpack_public_path__ + "static/media/sprite-v4.ea86689d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sprite-v4.svg
// module id = 106
// module chunks = 0